import { render, staticRenderFns } from "./MFASetup.vue?vue&type=template&id=00097e32&scoped=true"
import script from "./MFASetup.vue?vue&type=script&lang=js"
export * from "./MFASetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00097e32",
  null
  
)

export default component.exports